export enum actionTypes {
  FETCH_DCDD_MEMBERSHIP_REQUEST = "FETCH_DCDD_MEMBERSHIP_REQUEST",
  FETCH_DCDD_MEMBERSHIP_SUCCESS = "FETCH_DCDD_MEMBERSHIP_SUCCESS",
  FETCH_DCDD_MEMBERSHIP_FAIL = "FETCH_DCDD_MEMBERSHIP_FAIL",
  //Create Packages
  CREATE_DCDD_MEMBERSHIP_PLAN_REQUEST = "CREATE_DCDD_MEMBERSHIP_PLAN_REQUEST",
  CREATE_DCDD_MEMBERSHIP_PLAN_SUCCESS = "CREATE_DCDD_MEMBERSHIP_PLAN_SUCCESS",
  CREATE_DCDD_MEMBERSHIP_PLAN_FAIL = "CREATE_DCDD_MEMBERSHIP_PLAN_FAIL",
  //Update Packages
  UPDATE_DCDD_MEMBERSHIP_PLAN_REQUEST = "UPDATE_DCDD_MEMBERSHIP_PLAN_REQUEST",
  UPDATE_DCDD_MEMBERSHIP_PLAN_SUCCESS = "UPDATE_DCDD_MEMBERSHIP_PLAN_SUCCESS",
  UPDATE_DCDD_MEMBERSHIP_PLAN_FAIL = "UPDATE_DCDD_MEMBERSHIP_PLAN_FAIL",
  //update status
  UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_REQUEST = "UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_REQUEST",
  UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_SUCCESS = "UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_SUCCESS",
  UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_FAIL = "UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_FAIL",
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface DcddMembershipPlanProp {
  created_at: string;
  end_date: string;
  id: string;
  join_date: string;
  membership_plan: string;
  remarks: string;
  status: string;
  updated_at: string;
  user_limit: number;
}
export interface CreateDcddMembershipPlanInput {
  user_limit: number;
  remarks: string;
  end_date: string;
  membership_plan: string;
}
export interface CreateDcddMembershipPlanInputError {
  user_limit?: string;
  remarks?: string;
  end_date?: string;
  membership_plan?: string;
}
export interface UpdateDcddMembershipPlanInput {
  user_limit: number;
  remarks: string;
  user_membership_id: string;
  end_date: string;
  membership_plan: string;
}
export interface UpdateDcddMembershipPlanStatrusInput {
  status:string;
  user_membership_id: string;
}

//fetch membership
export interface FetchDcddMembershipRequestAction {
  type: actionTypes.FETCH_DCDD_MEMBERSHIP_REQUEST;
}

export interface FetchDcddMembershipSuccessAction {
  type: actionTypes.FETCH_DCDD_MEMBERSHIP_SUCCESS;
  payload: DcddMembershipPlanProp[];
}

export interface FetchDcddMembershipFailureAction {
  type: actionTypes.FETCH_DCDD_MEMBERSHIP_FAIL;
  payload: string;
}

//create package
export interface CreateDcddMembershipRequestAction {
  type: actionTypes.CREATE_DCDD_MEMBERSHIP_PLAN_REQUEST;
}

export interface CreateDcddMembershipSuccessAction {
  type: actionTypes.CREATE_DCDD_MEMBERSHIP_PLAN_SUCCESS;
  payload: DcddMembershipPlanProp;
}

export interface CreateDcddMembershipFailureAction {
  type: actionTypes.CREATE_DCDD_MEMBERSHIP_PLAN_FAIL;
  payload: string;
}

//Update package
export interface UpdateDcddMembershipRequestAction {
  type: actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_REQUEST;
}
export interface UpdateDcddMembershipSuccessAction {
  type: actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_SUCCESS;
  payload: DcddMembershipPlanProp;
}
export interface UpdateDcddMembershipFailAction {
  type: actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_FAIL;
  payload: string;
}
//Update Status
export interface UpdateDcddMembershipStatusRequestAction {
  type: actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_REQUEST;
}
export interface UpdateDcddMembershipStatusSuccessAction {
  type: actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_SUCCESS;
  payload: DcddMembershipPlanProp;
}
export interface UpdateDcddMembershipStatusFailAction {
  type: actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_FAIL;
  payload: string;
}

export type DcddMembershipActions =
  | FetchDcddMembershipRequestAction
  | FetchDcddMembershipSuccessAction
  | FetchDcddMembershipFailureAction
  | CreateDcddMembershipRequestAction
  | CreateDcddMembershipSuccessAction
  | CreateDcddMembershipFailureAction
  | UpdateDcddMembershipRequestAction
  | UpdateDcddMembershipSuccessAction
  | UpdateDcddMembershipFailAction
  | UpdateDcddMembershipStatusRequestAction
  | UpdateDcddMembershipStatusSuccessAction
  | UpdateDcddMembershipStatusFailAction;
